import { useEffect, useState } from "react";

export type VisualViewportRect = {
  height: number;
  offsetTop: number;
};

export const useVisualViewport = (enabled: boolean = true): VisualViewportRect | undefined => {
  const [rect, setRect] = useState<VisualViewportRect | undefined>(undefined);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!enabled || !viewport) {
      setRect(undefined);
      return;
    }

    const update = () => setRect({ height: viewport.height, offsetTop: viewport.offsetTop });
    update();

    viewport.addEventListener("resize", update);
    viewport.addEventListener("scroll", update);
    return () => {
      viewport.removeEventListener("resize", update);
      viewport.removeEventListener("scroll", update);
    };
  }, [enabled]);

  return rect;
};
